import { useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'

import { RadioButton } from 'Components/_theme'

import { FieldRadioButtonProps } from './Field.types'

export const FieldRadioButton = (props: FieldRadioButtonProps) => {
  const {
    className,
    label,
    name,
    hasError,
    markAsRequired,
    shouldTranslateLabel,
    ...rest
  } = props
  const { register } = useFormContext()
  const intl = useIntl()

  const translatedLabel =
    shouldTranslateLabel && label
      ? intl.formatMessage({
          id: label,
        })
      : label ?? ''

  const formattedLabel = `${translatedLabel} ${
    markAsRequired ? '*' : ''
  }`.trim()

  return (
    <RadioButton
      {...register(name)}
      {...rest}
      className={className}
      isInvalid={hasError}
      label={formattedLabel}
    />
  )
}
